module.exports = __webpack_public_path__ + "static/media/report_8.955b489b.jpg";